import { FormHelperText, styled } from '@mui/material';

export const StyledFormHelperText = styled(FormHelperText)({
  fontFamily: 'Graphik',
  lineHeight: '16px',
  color: '#DF0000',
  marginTop: '-12px',
  marginBottom: '12px',
});
